import { createFileRoute } from '@tanstack/react-router';
import {
  BackgroundFiltersProvider,
  StreamCall,
  StreamTheme,
  useCalls,
} from '@stream-io/video-react-sdk';
import { useContext } from 'react';
import { ThemeContext } from '@/context/theme-context';
import '@stream-io/video-react-sdk/dist/css/styles.css';
import { InprogressCall } from '@/components/video-call/in-progress-call/in-progress-call';

export const Route = createFileRoute('/auth/video/call/')({
  component: RouteComponent,
});

function RouteComponent() {
  const calls = useCalls();
  const { theme } = useContext(ThemeContext);

  return (
    <StreamTheme as="main" className={theme}>
      <StreamCall call={calls[0]}>
        <BackgroundFiltersProvider backgroundFilter="blur" backgroundBlurLevel="low">
          <InprogressCall />
        </BackgroundFiltersProvider>
      </StreamCall>
    </StreamTheme>
  );
}
